import { Entity, Field } from 'typegraph';

@Entity({ create: "purchaseByCredit" })
export class CreditsPayment {

    @Field()
    entityId: number;

}


// WEBPACK FOOTER //
// ./src/panels/checkout/entities/CreditsPayment.ts